export default class AsyncResult {
    public Success: boolean = false;
    public ErrorMessage: string = "";
    public ResultCount: number = 0;
    public Data: any;
}
